<template>
  <EmailVerificationShared type="newsletter" />
</template>

<script setup>
import EmailVerificationShared from '@/components/EmailVerificationShared.vue'
</script>
